export const books = [
  {
    id: 1,
    price: 10.5,
    rating: 5,
    title: "Atomic Habits",
    author: "James Clear",
    reviews: "69,548",
    image: "atomic-habits.jpg",
    printLength: 320,
    language: "English",
    PublicationDate: "16 April 2018",
    inStock: true,
    description:
      "Atomic Habits by James Clear is a self-help book that focuses on the power of small, incremental changes to build good habits and break bad ones. It emphasizes that consistent, small improvements, even just 1% better each day, can lead to remarkable results over time. The book provides a practical framework for habit formation based on four laws: Make it Obvious, Make it Attractive, Make it Easy, and Make it Satisfying.",
  },
  {
    id: 2,
    price: 14,
    rating: 5,
    title: "Confess",
    author: "Colleen Hoover",
    reviews: "3,980",
    image: "confess.jpg",
    printLength: 410,
    language: "English",
    PublicationDate: "1 March 2015",
    inStock: true,
    description:
      "Confess by Colleen Hoover tells the story of Auburn Reed, who, after experiencing significant loss, is trying to rebuild her life. She encounters Owen Gentry, an artist whose work is inspired by anonymous confessions, and they are drawn to each other. However, Owen is hiding a secret that could shatter their relationship and everything Auburn believes. The novel explores themes of love, loss, betrayal, and the power of confession, with a focus on how trust can be fragile when dealing with secrets. ",
  },
  {
    id: 3,
    price: 9.05,
    rating: 5,
    title: "The Trouble With Hating You",
    author: "Sajni Patel",
    reviews: "235",
    image: "the-trouble-with-hating-you.jpg",
    printLength: 352,
    language: "English",
    PublicationDate: "1 June 2019",
    inStock: true,
    description:
      "The Trouble With Hating You is a hate-to-love romance novel by Sajni Patel about Liya Thakkar, a fiercely independent Indian-American biochemical engineer, and Jayesh Shah, a charming lawyer. When Liya discovers her parents are trying to set her up with Jay, she walks out. However, their paths unexpectedly cross again when Jay is hired to rescue Liya's struggling company. Despite their initial dislike, they find themselves drawn to each other, leading to witty banter and late-night chats. The story explores themes of cultural expectations, personal independence, and the complexities of love and trust, with a backdrop of family dynamics and past traumas. ",
  },
  {
    id: 4,
    price: 16.45,
    rating: 4.5,
    title: "Hopeless",
    author: "Colleen Hoover",
    reviews: "1,587",
    image: "hopeless.jpg",
    printLength: 416,
    language: "English",
    PublicationDate: "8 October 2012",
    inStock: true,
    description:
      "Hopeless by Colleen Hoover, tells the story of Sky, a 17-year-old who experiences public high school for the first time and encounters Dean Holder, a boy with a reputation and a mysterious past that intertwines with her own. As they grow closer, Sky begins to remember parts of her childhood before her adoption, and the two embark on a journey to uncover the truth about their pasts. The novel explores themes of love, loss, and the power of truth in healing emotional scars.",
  },
  {
    id: 5,
    price: 8,
    rating: 4,
    title: "Rich Dad Poor Dad",
    author: "Robert T.Kiyosaki",
    reviews: "8,661",
    image: "rich-dad-poor-dad.jpg",
    printLength: 336,
    language: "English",
    PublicationDate: "27 April 2017",
    inStock: true,
    description:
      "Rich Dad Poor Dad is a personal finance book by Robert Kiyosaki, contrasting the financial advice of his two father figures: his biological father (poor dad) and his best friend's father (rich dad). The book emphasizes the importance of financial literacy, understanding assets and liabilities, and building wealth through entrepreneurship and investing, rather than solely relying on traditional employment. ",
  },
  {
    id: 6,
    price: 21,
    rating: 3.5,
    title: "One True Loves",
    author: "Taylor Jenkins Reid",
    reviews: "2,421",
    image: "one-true-love.jpg",
    printLength: 342,
    language: "English",
    PublicationDate: "17 July 2016",
    inStock: true,
    description:
      "One True Loves by Taylor Jenkins Reid tells the story of Emma Blair, who loses her husband, Jesse, in a helicopter accident. Years later, she finds love again and gets engaged to her childhood friend, Sam. Just when she's about to remarry, Jesse is found alive, forcing Emma to confront her past and decide who her 'one true love' truly is. The novel explores themes of love, loss, and the complexities of choosing between two loves. ",
  },
  {
    id: 7,
    price: 11.05,
    rating: 4.5,
    title: "Think And Grow Rich",
    author: "Napolen Hill",
    reviews: "57,521",
    image: "think-and-grow-rich.jpg",
    printLength: 320,
    language: "English",
    PublicationDate: "1 September 2005",
    inStock: true,
    description:
      "Think and Grow Rich by Napoleon Hill is a self-help book that outlines a 13-step plan for achieving success and wealth, based on the author's study of over 500 of the most successful people of his time. The core idea is that success originates in the mind, and by cultivating a positive, goal-oriented mindset, individuals can attract wealth and abundance into their lives. ",
  },
  {
    id: 8,
    price: 7.05,
    rating: 4.5,
    title: "Never Split The Difference",
    author: "Chris Voss",
    reviews: "17,980",
    image: "never-split-the-difference.jpg",
    printLength: 288,
    language: "English",
    PublicationDate: "23 March 2017",
    inStock: true,
    description:
      "Never Split the Difference by Chris Voss is a negotiation book that draws on the author's experience as an FBI hostage negotiator. It argues that traditional negotiation tactics, like compromising, are often ineffective. Instead, the book advocates for using emotional intelligence, active listening, and strategic communication to understand and influence the other party's perspective and ultimately achieve better outcomes. ",
  },
  {
    id: 9,
    price: 12.58,
    rating: 5,
    title: "Good Vibes, Good Life",
    author: "Vex King",
    reviews: "22,252",
    image: "it-ends-with-us.jpg",
    printLength: 325,
    language: "English",
    PublicationDate: "4 December 2018",
    inStock: true,
    description:
      "Good Vibes, Good Life is a self-help book by Vex King that explores the power of self-love and positive thinking to unlock one's potential and create a fulfilling life. The book emphasizes the importance of self-care, overcoming negative influences, cultivating positive habits, and manifesting goals. It encourages readers to shift their mindset, embrace self-compassion, and align their actions with their desires to attract positive energy and experiences. ",
  },
  {
    id: 10,
    price: 5.98,
    rating: 4.5,
    title: "Beginning Drawing Atelier",
    author: "Juliette Aristides",
    reviews: "661",
    image: "beginning.jpg",
    printLength: 128,
    language: "English",
    PublicationDate: "16 April 2018",
    inStock: false,
    description:
      "Beginning Drawing Atelier by Juliette Aristides is a comprehensive instructional sketchbook designed to teach fundamental drawing skills using traditional atelier methods. It breaks down the drawing process into manageable lessons, guiding beginners from basic lines to finished drawings. The book emphasizes practical application, featuring blank pages for copying and practicing, mirroring the atelier learning environment. ",
  },
];
